import { render, staticRenderFns } from "./pos-print-ticket.vue?vue&type=template&id=08ccf210&scoped=true&"
import script from "./pos-print-ticket.ts?vue&type=script&lang=ts&"
export * from "./pos-print-ticket.ts?vue&type=script&lang=ts&"
import style0 from "./pos-print-ticket.scss?vue&type=style&index=0&id=08ccf210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccf210",
  null
  
)

export default component.exports